"use strict";
wp.customize.controlConstructor['epsilon-toggle'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        control.container.on('change', 'input.onoffswitch-checkbox', function (e) {
            control.setting.set(jQuery(e.target).prop('checked'));
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/toggle.ts
// module id = 22
// module chunks = 0